(function () {
  'use strict';

  var REDUCE_MOTION = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (!root || root.dataset.htoStepsInit === 'true') return;

    var track = root.querySelector('[data-hto-steps-track]');
    if (!track) return;

    var slides   = Array.prototype.slice.call(track.children);
    var prev     = root.querySelector('[data-hto-steps-prev]');
    var next     = root.querySelector('[data-hto-steps-next]');
    var dotsWrap = root.querySelector('[data-hto-steps-dots]');
    var controls = root.querySelector('.hto-steps__controls');

    root.dataset.htoStepsInit = 'true';

    // Edge case: 0–1 slides — nothing to scroll, hide the controls.
    if (slides.length <= 1) {
      if (controls) controls.style.display = 'none';
      return;
    }

    // Build dots
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hto-steps__dot';
        dot.setAttribute('aria-label', 'Go to step ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function offsetOf(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }

    function currentIndex() {
      var pos = track.scrollLeft, best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(offsetOf(i) - pos);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function goTo(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      var left = offsetOf(i);
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: REDUCE_MOTION ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left; // very old browsers
      }
    }

    function update() {
      // Position-based bounds tolerate sub-pixel widths.
      var atStart = track.scrollLeft <= 1;
      var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (dots.length) {
        var idx = currentIndex();
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      }
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    // Keep arrows/dots in sync after manual swipe or drag (rAF-throttled).
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    // Keyboard: arrow keys when focus is inside the carousel.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(currentIndex() - 1); }
      else if (e.key === 'ArrowRight') { goTo(currentIndex() + 1); }
    });

    // Recompute bounds when widths change (rotate, responsive breakpoint).
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { update(); }).observe(track);
    } else {
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t); t = setTimeout(update, 150);
      });
    }

    update();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-hto-steps-carousel]')
      .forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init the section when it's re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();